import { Module, MutationTree, ActionTree, GetterTree } from "vuex";
import { loadDynamicPage, loadPageData, postPage } from "@/api/pages";
import { CustomPageMeta } from "@/interfaces/CustomPageMeta";
import { Page } from "@/interfaces/Page";

export interface RootState {
  id?: string;
  custom?: Page & CustomPageMeta;
  all: Page[];
}

const state: RootState = {
  id: undefined,
  custom: undefined,
  all: []
};

const mutations: MutationTree<typeof state> = {
  setId(state, payload) {
    state.id = payload;
  },
  setCustomPage(state, payload) {
    state.custom = payload;
  },
  setAllPages(state, payload) {
    state.all = payload;
  }
};

const actions: ActionTree<typeof state, unknown> = {
  fetchDynamic(context, id) {
    // Use context
    const basePath = process.env.BASE_URL;
    return new Promise((resolve, reject) => {
      loadDynamicPage(id, basePath)
        .then(data => {
          console.log("Resolved!");

          if (data != null) {
            context.commit("setId", data.id);
            context.commit("setCustomPage", data);
          } else {
            reject({ message: "invalid page id", code: 404 });
          }
          resolve(data);
        })
        .catch(_ => {
          reject({ message: "invalid page id", code: 404 });
        });
    });
  },
  async fetchAll(context) {
    if (context.state.all.length == 0) {
      const basePath = process.env.BASE_URL;
      const data = await loadPageData(basePath);
      context.commit("setAllPages", data);
      return data;
    }
    return context.state.all;
  },
  async postPage({ commit, state }, payload) {
    const token = payload.token || "";
    delete payload["token"];
    console.log(payload, token);
    
    const page = await postPage(process.env.BASE_URL, token, payload);
    // find the page by id.
    const selectedPage = state.all.find(p => p.id == payload.id);
    if (!selectedPage) {
      throw "Page not found.";
    }
    console.log("Get page ID back");

    const merged = { ...selectedPage, ...page };
    commit("setId", page.uid);
    commit("setCustomPage", merged);
    return merged;
  }
};

const getters: GetterTree<typeof state, unknown> = {
  customImageURL(state) {
    let base = "/";
    // Allow for local development
    if (process.env.NODE_ENV == "development") {
      base = "https://dev.alonetogethercoloringbook.com/";
    }
    if (state.custom) {
      return `${base}${state.custom.img}`;
    }
  }
};

export const page: Module<typeof state, unknown> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
